import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import AdditionalInfoModal from '#client/components/AdditionalInfoModal';
import ResetPinModal from '#client/components/ResetPinModal';
import SetPinModal from '#client/components/SetPinModal';
import useModalContext from '#client/hooks/useModalContext';

/**
 * Maps modal keys from URL search parameters to their corresponding React components.
 * @type {object<string, import('react').ComponentType<any>>}
 */
const modalComponentMap = {
  'set-pin': SetPinModal,
  'reset-pin': ResetPinModal,
  'additional-info': AdditionalInfoModal
};

/**
 * Custom hook that automatically opens modals based on URL search parameters.
 *
 * This hook monitors the 'm' query parameter in the URL and automatically opens
 * the corresponding modal when the parameter is present. It supports opening
 *
 * @returns {void} This hook doesn't return any value
 *
 */
export const useQueryParamModal = () => {
  const { openModal } = useModalContext();
  const [searchParams] = useSearchParams();
  const modalKey = searchParams.get('m');

  useEffect(() => {
    if (!modalKey) {
      return;
    }

    const component = modalComponentMap[modalKey];
    if (!component) {
      return;
    }

    openModal({
      component
    });
  }, [modalKey, openModal]);
};
